import React from "react";

const AxoFooter = () => {
  return <div className="axolexfooter">© Powered By Axolex</div>;
};

export default AxoFooter;
